import axios from './axios'
import { getCookie } from './helper'
import { url as urlObj } from '@zz-yp/hunter-js-utils'

export const isExam = async () => {
  // 采货侠小程序专用, 非采货侠小程序内，不存在小程序审核状态（t = 134）
  if (+getCookie('t') !== 134) return false
  const url = 'https://feconf.zhuanzhuan.com/feconf/hunter'
  const res = await axios.get(url, { keys: 'hunter-mini' })
  const { isExamining, version } = res
  const currVersion = urlObj.getParam('miniVersion') || ''
  return isExamining && version == currVersion
}
